import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'xcentric-xcentric',
  template: `
    <p>
      <p-dropdown [options]="[]"></p-dropdown>
    </p>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class XcentricComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
